// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3tOg1","title":"FrontImage_title__2fQCF"};